import { Injectable, Inject, Optional } from '@angular/core';
import { EMPTY, of } from 'rxjs';
import { Store } from '@ngrx/store';
import { IAppState } from '../app.state';
import { REQUEST } from '@nguniversal/express-engine/tokens';
import { setIsPreview, setTheme } from '../visual/visual.actions';
import { Meta } from '../../angular2-meta';
import { setBrandingTheme } from './branding.actions';

@Injectable({
  providedIn: 'root'
})
export class BrandingResolverService {

  constructor(
    public _store: Store<IAppState>,
    @Optional() @Inject(REQUEST) public request: any,
    @Inject('isBrowser') public isBrowser: boolean,
    public _meta: Meta,
  ) { }

  resolve() {
    let isPreview;
    let brandingTheme;
    if(this.isBrowser) {
      isPreview = this.detectIsPreview(window.location.search);
      if(isPreview) {
        brandingTheme = this.getBrandingParams(window.location.search);
      }
    }

    if(brandingTheme) {
      this._store.dispatch(setBrandingTheme(brandingTheme));
      if(brandingTheme.theme) {
        this._store.dispatch(setTheme(brandingTheme.theme));
      }
    }
    this._store.dispatch(setIsPreview(isPreview));
    return of(EMPTY);
  }

  detectIsPreview(url) {
    return url.indexOf('preview') != -1;
  }

  getBrandingParams(search) {
    var params = search
    .replace('?','')
    .split('&')
    .reduce(
        function(p,e){
            var a = e.split('=');
            if(a[0] != 'preview') {
              let value = decodeURIComponent(a[1]);
              let typedValue;
              if(value == 'true' || value == 'false') {
                typedValue = value == 'true' ? true : false;
              } else {
                typedValue = value;
              }
              p[ decodeURIComponent(a[0])] = typedValue;
            }
            return p;
        },
        {}
    );
    return params
  };
}
